<template>
  <div class="registration-success--wrap">
    <div class="content--header">
      <i class="icon icon--check-green-size40"></i>
      <strong>{{ $t('page.getTrackingCode.title') }}</strong>
      <p class="desc" v-html="$t('page.getTrackingCode.desc')"></p>
    </div>
<!--    <div class="update">-->
<!--      <div style="display: flex; align-items: center; column-gap: 8px;">-->
<!--        <i class="update__image" alt=""></i>-->
<!--        <span class="update__info" v-html="updateText"></span>-->
<!--      </div>-->
<!--      <div style="display: flex; align-items: center; column-gap: 5px;">-->
<!--        <a class="update__more" :href="newCodeInfoLink" target="_blank">{{ $t('common.trackingCode.update.more') }}</a>-->
<!--        <a class="update__contact" href="https://www.beusable.net/contact" target="_blank">{{ $t('common.trackingCode.update.contact') }}</a>-->
<!--      </div>-->
<!--    </div>-->
    <div class="content--body">
      <p class="sub-title">{{ $t('page.getTrackingCode.content.title') }}</p>
      <p class="desc" v-html="$t('page.getTrackingCode.content.desc')"></p>
      <p class="tip">
        <i class="icon-text">Tip!</i>
        <span v-html="$t('page.getTrackingCode.content.tip')"></span>
      </p>
      <div class="content__code--wrap">
        <div class="content">
          <div class="content__line" v-if="bAMP">
            <span>1</span>
          </div>
          <div class="content__line" v-else>
            <span>1</span>
            <span>2</span>
            <span>3</span>
            <span>4</span>
            <span>5</span>
            <span>6</span>
            <span>7</span>
            <span>8</span>
            <span>9</span>
            <span>10</span>
            <span>11</span>
          </div>
          <div class="content__code">
            <pre>{{ trackingCode }}</pre>
          </div>
        </div>
        <div class="content__toast" v-if="showToastLayer">
          <span>{{ $t('common.trackingCode.copied') }}</span>
          <i class="icon icon--check-green-size16"></i>
        </div>
      </div>
    </div>
    <div class="button--wrap">
      <button class="btn__copy" @click="copyCode">{{ $t('common.copy') }}</button>
      <router-link :to="{ name: 'dashboard', query: { sid } }"
                   class="btn__move"
                   tag="button">{{ $t('common.goToList') }}</router-link>
    </div>
  </div>
</template>

<script>
import { getCode, getCodeForAMP } from '@/api/apply'
import { NEW_CODE_DEPLOY_DATE, NEW_CODE_INFO_LINK } from '@/libs/constants'
import { getUserInfo } from '../../api/user'

export default {
  data () {
    return {
      trackingCode: '',
      showToastLayer: false,
      updateText: '',
      newCodeInfoLink: NEW_CODE_INFO_LINK
    }
  },
  props: [
    'sid',
    'bAMP'
  ],
  methods: {
    copyCode () {
      let range = document.createRange()
      range.setStartBefore(document.querySelector('pre'))
      range.setEndAfter(document.querySelector('pre'))
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
      document.execCommand('copy')
      this.showToastLayer = true
      setTimeout(() => {
        this.showToastLayer = false
      }, 5000)
    }
  },
  created () {
    if (this.bAMP) {
      getCodeForAMP(this.sid).then(res => {
        this.trackingCode = res
      })
    } else {
      getCode(this.sid).then(res => {
        this.trackingCode = res
      })
    }

    getUserInfo().then((result) => {
      this.updateText = this.$t('common.trackingCode.update.info.new')
      if (result.regDate && result.regDate < NEW_CODE_DEPLOY_DATE) {
        this.updateText = this.$t('common.trackingCode.update.info.old')
      }

      this.updateText = `<span style="font-weight: 500">${this.$t('common.trackingCode.update.info.guide')}</span><br>` + this.updateText
    })
  }
}
</script>

<style lang="scss" scoped>
.registration-success--wrap {
  width: 640px;
  height: 670px;
  border-radius: 34px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  margin: 104px auto 0;
  padding: 40px 20px 25px;
  box-sizing: border-box;

  .content--header {
    text-align: center;
    strong {
      display: block;
      font-size: 32px;
      font-weight: bold;
      line-height: 1.25;
      color: #1199af;
      margin-top: 15px;
    }
    .desc {
      font-size: 14px;
      line-height: 1.43;
      color: #444444;
      margin-top: 15px;
    }
  }
  .update {
    position: relative;
    left: -20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    box-sizing: border-box;
    width: 640px;
    height: 73px;
    margin-top: 34px;
    padding: 14px 15px;

    background-color: #f4e439;

    &__image {
      display: inline-block;
      width: 20px;
      height: 20px;

      background-image: url(../../assets/img/icon-trackingcode-new.svg);
    }

    &__info {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.46;
      letter-spacing: normal;
      color: #2f2f2f;
    }

    &__more {
      padding: 4px 12px;
      border-radius: 5px;
      background-color: #fff;

      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.46;
      letter-spacing: normal;
      text-align: center;
      color: #ec0047
    }

    &__contact {
      border-radius: 5px;
      background-color: #fff;
      padding: 4px 12px;

      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.46;
      letter-spacing: normal;
      text-align: center;
      color: #444;
    }
  }
  .content--body {
    margin-top: 32px;

    & > p {
      padding-left: 10px;
    }
    .sub-title {
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      color: #2f2f2f;
    }
    .desc {
      font-size: 12px;
      line-height: 1;
      color: #ec0047;
      margin-top: 15px;
    }
    .tip {
      position: relative;
      padding-left: 40px;
      margin-top: 20px;
      .icon-text {
        position: absolute;
        top: 1px;
        left: 10px;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.5;
        color: #57ab00;
      }
      span {
        font-size: 13px;
        line-height: 1.46;
        color: #767676;
      }
    }
    .content__code--wrap {
      position: relative;
      .content__toast {
        display: inline-block;
        height: 32px;
        border-radius: 6px;
        box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
        background-color: rgba(0,0,0,0.85);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding-left: 12px;
        padding-right: 45px;
        span {
          font-size: 13px;
          font-weight: bold;
          color: #57ab00;
          line-height: 32px;
        }
        i {
          position: absolute;
          top: 50%;
          right: 12px;
          transform: translateY(-50%);
        }
      }
    }
    .content {
      position: relative;
      margin: 21px auto 12px;
      width: 580px;
      height: 133px;
      overflow-y: auto;
      border-radius: 5px;
      border: solid 1px #d7d7d7;
      background-color: #f4f4f4;

      .content__line {
        width: 32px;
        position:absolute;
        top:0;
        bottom:0;
        left:0;
        border-radius: 4px;
        padding-top: 10px;
        padding-bottom: 10px;
        box-sizing: border-box;
        background-color: #fff;

        span {
          background-color: #fff;
          display:block;
          text-align:center;
          font-size: 13px;
          line-height: 1.54;
          color: #444444;
        }
      }
      .content__code {
        position: absolute;
        min-width: 500px;
        top: 0;
        bottom: 0;
        left: 45px;
        box-sizing: border-box;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 13px;
        line-height: 1.54;
        color: #444444;
      }
    }
  }
  .button--wrap {
    margin-top: 26px;
    text-align: center;

    button {
      @include buttonTypeNormal;
      height: 38px;
      &.btn__copy {
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        font-size: 14px;
        font-weight: bold;
        color: #444444;
      }
      &.btn__move {
        background-color: #ec0047;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        margin-left: 5px;
      }
    }
  }
}
</style>
